import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_stzes6vr2c: FaireBrandEntity = {
  token: "b_stzes6vr2c",
  type: "brand",
  name: "Al + Gray Graphic Tees",
  avatarUrl:
    "https://cdn.faire.com/fastly/e529ea4d6495c187bd55932b404f5fab3c2493812a38dab1b8e63fc11bcbda5a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c0969d082b8785523dca86d4f9466ab77667066a81a786e4a7d8674659449a22.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e529ea4d6495c187bd55932b404f5fab3c2493812a38dab1b8e63fc11bcbda5a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c0969d082b8785523dca86d4f9466ab77667066a81a786e4a7d8674659449a22.jpeg",
  location: "Beebe, AR, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 261,
  isTopShop: true,
  isInsider: true,
  description:
    "Al + Gray Graphic Tees was created with the every day girl in mind. We believe even graphic tees help express who you are - a mom, a christian, a summer lovin' free spirit. We cover many aesthetics with designs ranging from casual to feminine to western. Al + Gray stays up on the latest trends and offers diverse sizes. We're amping up the graphic tee game and can't wait to have you join our tribe!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:28.413Z",
    importedBy: "entity-db-cli",
  },
};
